import { useQuery } from "@tanstack/react-query";
import { m } from "framer-motion";
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

// Components
import Team from '../Components/Team/Team';
import { fadeIn } from '../Functions/GlobalAnimations';
import { db } from '../config/firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import FooterSection from './Footer/FooterSection';
import HeaderSection from './Header/HeaderSection';
import Preloader from "../Components/Preloader";

// Function to fetch team data
const fetchTeamData = async () => {
  try {
    const headerRef = collection(db, 'teamHeader');
    const bodyRef = collection(db, 'teamBody');
    const bodyQuery = query(bodyRef, orderBy('createdAt', 'desc'));

    const [headerSnapshot, bodySnapshot] = await Promise.all([
      getDocs(headerRef),
      getDocs(bodyQuery)
    ]);

    const header = headerSnapshot.docs.length > 0 ? headerSnapshot.docs[0].data().title : "Team";

    const body = bodySnapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        img: data.imageUrl,
        name: data.name,
        designation: data.designation
      };
    });

    return { header, body };
  } catch (error) {
    console.error("Error fetching team data:", error);
    throw error;
  }
};

const TeamDetail = (props) => {
  const { data: teamData, isLoading } = useQuery({
    queryKey: ["teamData"],
    queryFn: fetchTeamData,
  });

  if (isLoading) {
    return <Preloader/>;
  }

  return (
    <div style={{ ...props.style, fontFamily: "'Inter', system-ui, sans-serif" }}>
      {/* Header Start */}
      <HeaderSection theme={"light"} />
      {/* Header End */}

      {/* Hero Banner Start */}
      <m.section
        className="overflow-hidden relative"
        style={{
          backgroundColor: '#1a1a2e',
          marginTop: '100px',
          paddingTop: '60px',
          paddingBottom: '60px',
        }}
        {...fadeIn}
      >
        <Container fluid className="text-center">
          <Row>
            <Col className="text-center z-0">
              <span
                style={{
                  display: 'inline-block',
                  color: '#D4A853',
                  fontSize: '13px',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '2px',
                  marginBottom: '16px',
                  fontFamily: "'Inter', system-ui, sans-serif",
                }}
              >
                Our People
              </span>
              <h1
                style={{
                  color: '#ffffff',
                  fontSize: '2.5rem',
                  fontWeight: 700,
                  margin: 0,
                  fontFamily: "'Inter', system-ui, sans-serif",
                }}
              >
                {teamData?.header || 'Team'}
              </h1>
            </Col>
          </Row>
        </Container>
      </m.section>
      {/* Hero Banner End */}

      {/* Section Start */}
      <section
        id="downsection"
        className="our-team-page-team py-[40px] lg:pt-[30px] lg:pb-[20px] md:pt-[20px] md:pb-[10px] sm:py-[20px] xs:pb-[10px] switch-tabs"
        style={{ backgroundColor: '#FFFBF5' }}
      >
        <Container fluid className="px-[7%] lg:px-[3%]">
          <Team
            themeColor="light"
            overlay={["#1a1a2e", "#D4A853", "#7BAE7F", "#1a1a2e", "#D4A853"]}
            theme='team-style-04'
            data={teamData?.body || []}
            grid="row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 justify-center"
            carousel={false}
            carouselOption={{ slidesPerView: 3, spaceBetween: 30, loop: true, navigation: true, autoplay: { delay: 3000, disableOnInteraction: true }, pagination: { dynamicBullets: true, clickable: true } }} />
        </Container>
      </section>
      {/* Section End */}

      {/* Footer Start */}
      <FooterSection />
      {/* Footer End */}
    </div>
  );
}

export default TeamDetail;
